import { handleError, hasError, tryCatch } from '@repo/shared/api/helpers'
import { FeatureFlagRoutes } from '@repo/shared/routes-sudo'
import { AxiosInstance } from 'axios'

import { IFeatureFlagsApi } from '@/spi/api/feature-flags'

export const buildFeatureFlagsApi = (axios: AxiosInstance): IFeatureFlagsApi => ({
  getFeatureFlagsForOrganization: async (organizationId) => {
    const response = await tryCatch(async () =>
      axios.get<typeof FeatureFlagRoutes.getFeatureFlagsForOrganization.response>(
        FeatureFlagRoutes.getFeatureFlagsForOrganization.getPath({ organizationId }),
      ),
    )
    if (hasError(response)) return handleError(response)
    return response.data
  },

  toggleOrganization: async ({ featureFlagKey, organizationId, enabled }) => {
    const response = await tryCatch(async () =>
      axios.patch<typeof FeatureFlagRoutes.toggleOrganization.response>(
        FeatureFlagRoutes.toggleOrganization.getPath({ featureFlagKey, organizationId }),
        { payload: { enabled } } satisfies typeof FeatureFlagRoutes.toggleOrganization.request,
      ),
    )
    if (hasError(response)) return handleError(response)
    return response.data
  },
})
